export default [
  {
    type: 'index',
    formItems: [
      {
        label: "页面名称",
        name: "title",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '导购有礼',
      },
      {
        label: "背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 750*1334 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/guideTemplate.png',
      },

      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ff211d',
      },
      {
        label: "积分商城入口",
        name: "is_show_goods",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "导购中心入口",
        name: "is_show_center",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
      },
      {
        label: "摇一摇开奖",
        name: "is_show_shake",
        type: "text",
        stamp: 'radio',
        key: "params",
        options: [
          { label: '开启', value: true },
          { label: '关闭', value: false },
        ],
        tips:"使用苹果手机打开溯源页面时，无法使用摇一摇开奖功能，配置不生效"
      },
      {
        label: "摇一摇图片",
        name: "shakeBackgroundImage",
        key: "style",
        stamp: 'shakeImg',
      },
    ]
  },
  {
    type: 'success',
    formItems: [
      {
        label: "弹窗背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
      {
        label: "按钮颜色",
        name: "buttonColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FFAE59',
      },
      {
        label: "按钮文字颜色",
        name: "buttonTextColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
      {
        label: "积分提示语",
        name: "jifenTips",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '已到账，请前往会员中心查看',
      },
      {
        label: "红包提示语",
        name: "rebTips",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '红包将在24小时内发放',
      },
    ]
  },
  {
    type: 'repeat',
    formItems: [ 
      {
        label: "背景图",
        name: "icon",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 300*290 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/guideAwardBg.png',
      },
      {
        label: "按钮颜色",
        name: "buttonColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FFAE59',
      },
      {
        label: "按钮文字颜色",
        name: "buttonTextColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
    ]
  },
  {
    type: 'notWinning',
    formItems: [ 
      {
        label: "背景图",
        name: "icon",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 300*290 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/guideAwardBgNo.png',
      },
      {
        label: "按钮颜色",
        name: "buttonColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FFAE59',
      },
      {
        label: "按钮文字颜色",
        name: "buttonTextColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
    ]
  },
]